export const CANCEL_PREFERENCES = 'CANCEL_PREFERENCES';
export const SAVE_PREFERENCES = 'SAVE_PREFERENCES';
export const SHOW_PASSWORD_CONFIRMATION = 'SHOW_PASSWORD_CONFIRMATION';
export const SHOW_SAVE_CHANGES_CONFIRMATION = 'SHOW_SAVE_CHANGES_CONFIRMATION';
export const UPDATE_PASSWORD = 'UPDATE_PASSWORD';
export const GET_LEARNER_CAN_CHANGE_L2 = 'GET_LEARNER_CAN_CHANGE_L2';
export const SET_LEARNER_CAN_CHANGE_L2 = 'SET_LEARNER_CAN_CHANGE_L2';

const initialState = {
  showPasswordConfirmation: false,
  showSaveChangesConfirmation: false,
  showlearnerCanChangeL2: null
};

export const preferencesReducer = (preferencesState = initialState, action = null) => {
  switch (action && action.type) {
    case CANCEL_PREFERENCES:
    case SAVE_PREFERENCES:
    case GET_LEARNER_CAN_CHANGE_L2:
    case UPDATE_PASSWORD:
      return preferencesState;

    case SHOW_PASSWORD_CONFIRMATION:
      return {
        ...preferencesState,
        showPasswordConfirmation: action.payload.showPasswordConfirmation
      };

    case SHOW_SAVE_CHANGES_CONFIRMATION:
      return {
        ...preferencesState,
        showSaveChangesConfirmation: action.payload.showSaveChangesConfirmation
      };
    case SET_LEARNER_CAN_CHANGE_L2:
      return {
        ...preferencesState,
        showlearnerCanChangeL2: action.payload.learnerCanChangeL2
      };

    default:
      return preferencesState;
  }
};

export const preferencesActions = {
  setShowPasswordConfirmation: (showPasswordConfirmation) => ({
    type: SHOW_PASSWORD_CONFIRMATION,
    payload: { showPasswordConfirmation }
  }),
  processPasswordUpdate: (newPassword, existingPassword) => ({
    type: UPDATE_PASSWORD,
    payload: {
      newPassword: newPassword,
      existingPassword: existingPassword
    }
  }),
  cancelPreferences: () => ({ type: CANCEL_PREFERENCES, payload: {} }),
  savePreferences: (preferencesInfo) => ({
    type: SAVE_PREFERENCES,
    payload: { preferencesInfo: preferencesInfo }
  }),
  setShowSaveChangesConfirmation: (showSaveChangesConfirmation) => ({
    type: SHOW_SAVE_CHANGES_CONFIRMATION,
    payload: { showSaveChangesConfirmation }
  }),
  getLearnerCanChangeL2: () => ({ type: GET_LEARNER_CAN_CHANGE_L2 }),
  setLearnerCanChangeL2: (learnerCanChangeL2) => ({ type: SET_LEARNER_CAN_CHANGE_L2, payload: { learnerCanChangeL2 } })
};

export const preferencesSelectors = {
  showPasswordConfirmation: (state) => state.preferences.showPasswordConfirmation,
  showSaveChangesConfirmation: (state) => state.preferences.showSaveChangesConfirmation,
  showlearnerCanChangeL2: (state) => state.preferences.showlearnerCanChangeL2
};



// WEBPACK FOOTER //
// ./src/modules/preferences/reducer/preferences-reducer.js